import { useState } from 'react';
import { tokens } from '../../styles/designTokens';
import ErrorReportModal from './ErrorReportModal';

// Shared "?" support affordance. Renders inside modal panels (bottom-left slot)
// and in the desktop footer. Colour and size come from tokens — no raw literals.
// Only one sanctioned opt-out: ErrorReportModal itself (it IS the help surface).
export default function HelpButton({ size }) {
  const [open, setOpen] = useState(false);
  const diameter = size ?? tokens.help.sizeModal;

  return (
    <>
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        aria-label="Help"
        style={{
          position: 'absolute',
          bottom: 12,
          left: 12,
          width: diameter,
          height: diameter,
          borderRadius: '50%',
          backgroundColor: tokens.colors.help,
          color: '#FFFFFF',
          border: 'none',
          cursor: 'pointer',
          fontSize: Math.round(diameter * 0.5),
          fontWeight: 700,
          fontFamily: tokens.typography.fontFamily,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        ?
      </button>
      <ErrorReportModal
        isOpen={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
